import * as B from '@blueprintjs/core';
import * as I from 'immutable';
import React from 'react';

import {ApiOrganization, ApiOrganizationUser} from 'app/modules/Remote/Organization';
import CustomizeTagsDialog from 'app/pages/MonitorProjectView/CustomizeTagsDialog';
import {LoggedInUserActions} from 'app/providers/AuthProvider';
import {USER_ROLE_READONLY} from 'app/utils/constants';
import * as tagUtils from 'app/utils/tagUtils';

export const OrganizationTags: React.FunctionComponent<
  React.PropsWithChildren<{
    organization: I.ImmutableOf<ApiOrganization>;
    profile: I.ImmutableOf<ApiOrganizationUser>;
    setTags: LoggedInUserActions['setOrganizationTags'];
  }>
> = ({organization, profile, setTags}) => {
  const [manageTagsOpen, setManageTagsOpen] = React.useState(false);
  const [tagsKind, setTagsKind] = React.useState<tagUtils.TAG_KIND>(tagUtils.TAG_KIND.FEATURE);

  const canEditTags = profile.get('role') !== USER_ROLE_READONLY;

  const manageTagsAction = (kind: tagUtils.TAG_KIND, isOpen: boolean) => {
    setTagsKind(kind);
    setManageTagsOpen(isOpen);
  };

  return (
    <>
      <div>
        <B.Button
          onClick={() => manageTagsAction(tagUtils.TAG_KIND.FEATURE, true)}
          disabled={!canEditTags}
          icon="cog"
        >
          Property tags
        </B.Button>
      </div>
      <div>
        <B.Button
          onClick={() => manageTagsAction(tagUtils.TAG_KIND.NOTE, true)}
          disabled={!canEditTags}
          icon="cog"
        >
          Note tags
        </B.Button>
      </div>
      {manageTagsOpen && (
        <CustomizeTagsDialog
          organization={organization}
          kind={tagsKind}
          setTags={setTags}
          onClose={() => manageTagsAction(tagsKind, false)}
        />
      )}
    </>
  );
};
